import { ZxcvbnFactory } from '@zxcvbn-ts/core'

let zxcvbn: ZxcvbnFactory | null = null

export async function getZxcvbn(): Promise<ZxcvbnFactory> {
  if (!zxcvbn) {
    await (async () => {
      const { dictionary: enDictionary, translations: enTranslations } =
        await import('@zxcvbn-ts/language-en')
      const { dictionary: nlBeDictionary, translations: nlBeTranslations } =
        await import('@zxcvbn-ts/language-nl-be')
      const { adjacencyGraphs, dictionary: commonDictionary } =
        await import('@zxcvbn-ts/language-common')

      zxcvbn = new ZxcvbnFactory({
        translations: { ...enTranslations, ...nlBeTranslations },
        dictionary: { ...commonDictionary, ...enDictionary, ...nlBeDictionary },
        graphs: adjacencyGraphs
      })
    })()
  }
  return zxcvbn!
}
